import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

(function () {
	const parallaxContainers = document.querySelectorAll("[data-parallax-trigger]");

	parallaxContainers.forEach((container) => {
		const parallaxItems = container.querySelectorAll("[data-parallax]");

		parallaxItems.forEach((parallaxEl) => {
			const speed = parseFloat(parallaxEl.getAttribute("data-parallax-speed")) || 1;
			const direction = parallaxEl.getAttribute("data-parallax-direction") || "up";

			const toY = direction === "up" ? -2 : 2;

			gsap.to(parallaxEl, {
				y: () => (toY - speed) * 3000,
				ease: "none",
				scrollTrigger: {
					trigger: container,
					start: 0,
					end: "max",
					scrub: 0.5, // Smoothly follows scroll
					invalidateOnRefresh: true,
				},
			});
		});
	});
})();
